var target = document.getElementById("total_amount_changes");
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    var newValue = $(".gpo-total-text").find(".money").text();
    if (newValue) {
      $("#add-ons-price").val(newValue);
    }

    // changeTheBuildSummaryPrice();
  });
});
var config = { childList: true, subtree: true };
if (target) {
  observer.observe(target, config);
}

function changeTheBuildSummaryPrice() {
  updateSpecList($(".custom-spec-lists").first());
  updateSpecList($(".custom-spec-lists.mobile").first());
}

function updateSpecList(specList) {
  var liElements = specList.find("li");

  liElements.each(function () {
    var dataName = $(this).data("name");
    var correspondingElement = $('.gpo-container [name="' + dataName + '"]');
    var correspondingValuePrice;
    var correspondingValue;
    var correspondingValueEle;

    if (
      $('[name="' + dataName + '"]')
        .parent()
        .parent()
        .attr("data-clo-display") === "show"
    ) {
      $(this).hide();
    } else {
      $(this).show();
    }

    if (correspondingElement.is(":radio")) {
      correspondingValueEle = $(
        '.gpo-container [name="' + dataName + '"]:checked'
      );
      if (correspondingValueEle.length >= 1) {
        correspondingValue = correspondingValueEle.val();
        correspondingValuePrice = correspondingValueEle
          .parent()
          .find(".addOn")
          .first()
          .text();
      }
      if (!correspondingValuePrice) {
        correspondingValuePrice = "+$0.00";
      }
      if (!correspondingValue) {
        correspondingValue = "Not Selected";
      }
      $(this)
        .find(".spec-price")
        .text(correspondingValuePrice.replace(/[()]/g, ""));
      $(this)
        .find(".value_summary")
        .text(
          correspondingValue.replace(/[()]/g, "").replace(/,(?=[^,]*$)/, "")
        );
    } else if (correspondingElement.is("select")) {
      correspondingValue = correspondingElement.val();
      if (correspondingValue) {
        correspondingValuePrice = correspondingElement
          .parent()
          .parent()
          .find(".addOn")
          .first()
          .text();
      }
      if (!correspondingValuePrice) {
        correspondingValuePrice = "+$0.00";
      }
      if (!correspondingValue) {
        correspondingValue = "Not Selected";
      }
      
     let formattedValuePrice = correspondingValuePrice?.replace(/[()]/g, "").split("+")[1] ?? "$0.00";
      $(this)
        .find(".spec-price")
        .text("+" + formattedValuePrice);
      $(this)
        .find(".value_summary")
        .text(
          correspondingValue.replace(/[()]/g, "").replace(/,(?=[^,]*$)/, "")
        );
    } else if (correspondingElement.is(":checkbox")) {
      correspondingValue = "";
      $('.gpo-container [name="' + dataName + '"]:checked').each(function () {
        correspondingValue += $(this).val() + ", ";
      });
      correspondingValuePrice = correspondingElement
        .parent()
        .parent()
        .parent()
        .find(".gpo-label")
        .find(".addOn")
        .first()
        .text();
      if (!correspondingValuePrice) {
        correspondingValuePrice = "+$0.00";
      }
      if (!correspondingValue) {
        correspondingValue = "Not Selected";
      }
      $(this)
        .find(".spec-price")
        .text("+" + correspondingValuePrice.replace(/[()]/g, "").split("+")[1]);
      $(this)
        .find(".value_summary")
        .text(
          correspondingValue.replace(/[()]/g, "").replace(/,(?=[^,]*$)/, "")
        );
    } else {
      correspondingValue = correspondingElement.val();
      correspondingValuePrice = correspondingElement
        .parent()
        .find(".addOn")
        .first()
        .text();
      if (!correspondingValuePrice) {
        correspondingValuePrice = "+$0.00";
      }
      if (!correspondingValue) {
        correspondingValue = "Not Selected";
      }
      $(this)
        .find(".spec-price")
        .text(correspondingValuePrice.replace(/[()]/g, ""));
      $(this)
        .find(".value_summary")
        .text(
          correspondingValue.replace(/[()]/g, "").replace(/,(?=[^,]*$)/, "")
        );
    }
  });
}
 

var changed = false;
const targetNode11 = document.querySelector("section.custom-options-section");

// Options for the observer (which mutations to observe)
const config11 = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback11 = (mutationList, observer) => {
  for (const mutation of mutationList) {
    changed = true;
  }
};

// Create an observer instance linked to the callback function
const observer11 = new MutationObserver(callback11);

// Start observing the target node for configured mutations
observer11.observe(targetNode11, config11);

const checkChanged = () => {
  return new Promise((resolve, reject) => {
    const checkInterval = setInterval(() => {
      if (changed) {
        clearInterval(checkInterval);
        resolve();
      }
    }, 400); // Adjust the interval as needed
  });
};

// Usage
checkChanged().then(() => {
  if (changed) {
    // Execute your function here
    observer11.disconnect();
    $("body")
      .find(".gpo-element")
      .each(function () {
        if ($(this).find("input").prop("checked")) {
          var sp = $("<span>")
            .addClass("addOn")
            .text($(this).find("input").val());
          $(this).find(".gpo-label").append(sp);
        }
        changeTheBuildSummaryPrice();
      });
  }
});

// Custom js
$("body").on("change", ".gpo-select select", function () {
  const $select = $(this);
  const $container = $select.parent().parent()
  const $addOn = $container.find(".addOn");
  const newValue = $select.val() + $addOn.text();
  if($addOn.length > 0){
    $addOn.text(newValue);
  }else{
      const $span = $("<span>").addClass("addOn").text(newValue);
    $container.find('.gpo-label').append($span);
  }

   changeTheBuildSummaryPrice();
});

$("body").on("change", ".gpo-radio input", function () {
  const $input = $(this);
  const $gpoLabel = $input.parent().parent().parent().find('.gpo-label');
  const $addOn = $gpoLabel.find('.addOn');

  if ($addOn.length > 0) {
    const newText = $input.val() + ' ' + $addOn.text();
    $addOn.text(newText);
  } else {
    const $span = $("<span>").addClass("addOn").text($input.val());
    $gpoLabel.append($span);
  }
   changeTheBuildSummaryPrice();
});

$("body").on("change", ".gpo-checkbox input", function () {
  var all_values = "";
  $('.gpo-checkbox input[name="' + $(this).attr("name") + '"]:checked').each(
    function () {
      all_values = all_values + $(this).val() + ",";
    }
  );
  all_values = all_values.substring(0, all_values.length - 1);
  if (
    $(this).parent().parent().parent().find(".gpo-label").find(".addOn")
      .length >= 1
  ) {
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".gpo-label")
      .find(".addOn")
      .text(
        all_values +
          $(this)
            .parent()
            .parent()
            .parent()
            .find(".gpo-label")
            .find(".addOn")
            .text()
      );
  } else {
    var sp = $("<span>").addClass("addOn").text(all_values);
    $(this).parent().parent().parent().find(".gpo-label").append(sp);
  }

   changeTheBuildSummaryPrice();
});

$("body").on("change", ".gpo-swatches input", function () {
  const $input = $(this);
  const $gpoLabel = $input.parent().parent().parent().find('.gpo-label');
  const $addOn = $gpoLabel.find('.addOn');
  const inputVal = $input.val();

  if ($addOn.length > 0) {
    $addOn.text(inputVal);
  } else {
    const $span = $("<span>").addClass("addOn").text(inputVal);
    $gpoLabel.append($span);
  }

   changeTheBuildSummaryPrice();
});

